import { useStore } from 'dg-web-shared/lib/Flux';
import * as LayoutState from '../../state/LayoutState';

import { ResponsiveProperties } from '../../utils/ResponsiveProperties';
import { TopNav } from './TopNav';
import { css } from '@emotion/css';

export function HeaderLargeBlock() {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    const responsiveProperties = new ResponsiveProperties(storeState);
    if (responsiveProperties.mobile) {
        return null;
    }

    return (
        <div className={css({ width: '100%', margin: 'auto' })}>
            <TopNav />
        </div>
    );
}
